import { render, staticRenderFns } from "./user-analytics.vue?vue&type=template&id=d117c95a&scoped=true&"
import script from "./user-analytics.vue?vue&type=script&lang=js&"
export * from "./user-analytics.vue?vue&type=script&lang=js&"
import style0 from "./user-analytics.vue?vue&type=style&index=0&id=d117c95a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d117c95a",
  null
  
)

export default component.exports